import { WalletKey } from "@silo/types";
import { cn } from "../../utils/class-names";
import { DialogButton } from "./dialog-button";

const FALLBACK_ERROR =
  "The connection failed. Please try again and follow the steps to connect your wallet.";

export interface FailedProps {
  className?: string;
  errorMessage?: string;
  walletKey: WalletKey;
  selectWallet: (value: WalletKey) => void;
  isPending: boolean;
  goBack: () => void;
}

export function Failed({
  className,
  errorMessage,
  walletKey,
  selectWallet,
  isPending,
  goBack,
}: FailedProps): JSX.Element {
  return (
    <div
      className={cn("flex flex-col gap-10", className)}
      data-cy="wallet-connection-error"
    >
      <div className="flex flex-col gap-5">
        <h2 className="text-xl font-medium text-white">Error connecting</h2>

        <p className="text-base text-shale-200">
          {errorMessage || FALLBACK_ERROR}
        </p>
      </div>

      <div className="flex flex-col items-stretch gap-5 sm:items-start">
        <DialogButton
          className="self-stretch sm:self-start"
          disabled={isPending}
          onClick={() => selectWallet(walletKey)}
        >
          Try again
        </DialogButton>

        <DialogButton
          className="self-stretch sm:self-start"
          disabled={isPending}
          onClick={goBack}
        >
          Back to wallet selection
        </DialogButton>
      </div>
    </div>
  );
}
